import { SettingsRemoteOutlined } from "@mui/icons-material";
import { Stack, Typography } from "@mui/material";
import CustomCard from "components/CustomCard";
import CustomLink from "components/CustomLink";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";

const Mcs = ({ data, setDialogTitle, getData }) => {
    const { bt } = useBizTypeTranslation();
    return (
        <CustomCard>
            <Stack direction="row" justifyContent="space-between">
                <Typography fontSize={18} fontWeight="bold"> {bt("MCS")}</Typography>
                <CustomLink title="IMPORT_DATA" onClick={() => getData()} />
            </Stack>

            <Stack
                useFlexGap
                sx={{ flexWrap: 'wrap' }}
                direction={{ xs: "column", md: "row" }}
                justifyContent={{ xs: "center", md: "start" }}
                spacing={{ xs: 1, md: 2 }}
            >
                {data?.filter(i => i?.show)?.map((st, idx) => {
                    return (
                        <CustomCard
                            key={idx}
                            alignItems="center"
                            direction="row"
                            width={{ xs: "100%", md: 250 }}
                            sx={{ cursor: "pointer" }}
                            onClick={() => {
                                setDialogTitle(bt(st?.name));
                                st?.onClick(st?.list)
                            }}
                        >
                            <Stack
                                width={{ xs: 50, md: 70 }}
                                height={{ xs: 50, md: 70 }}
                                bgcolor={st?.iconBgColor}
                                borderRadius={10}
                                alignItems="center"
                                justifyContent="center"
                            >
                                <SettingsRemoteOutlined sx={{ color: st?.iconColor }} />
                            </Stack>

                            <Stack padding={{ xs: 0, md: 1 }}>
                                <Typography fontSize={{ xs: 12, md: 14 }}>
                                    {bt(st?.name)}
                                </Typography>

                                <Stack height="100%" alignItems="center" direction="row" spacing={0.5}>
                                    <Typography fontSize={{ xs: 20, md: 24 }} fontWeight="bold">
                                        {st?.value}
                                    </Typography>
                                    <Typography fontSize={{ xs: 14, md: 14 }} fontWeight="bold">
                                        {`${st?.subValue ? `(${st?.subValue})` : ""}`}
                                    </Typography>
                                </Stack>
                            </Stack>
                        </CustomCard>
                    )
                })}


            </Stack>
        </CustomCard>
    );
};

export default Mcs;